import { trackPlatformEvent } from "./platformAnalytics";

function cleanValue(value, maxLength = 180) {
  if (value === null || value === undefined) return null;

  const cleaned = String(value).trim();
  return cleaned ? cleaned.slice(0, maxLength) : null;
}

function buildMetadata(params = {}) {
  const metadata = {
    service_id: cleanValue(params.service_id || params.serviceId),
    service_label: cleanValue(params.service_label || params.serviceLabel),
    service_type: cleanValue(params.service_type || params.serviceType),
    destination: cleanValue(params.destination),
    location: cleanValue(params.location),
    market_id: cleanValue(params.market_id || params.marketId),
    market_name: cleanValue(params.market_name || params.marketName),
    action: cleanValue(params.action),
    selected_date: cleanValue(params.selected_date || params.selectedDate),
    source_page: cleanValue(params.source_page || params.sourcePage),
    vibe_pass_context: Boolean(params.vibe_pass_context || params.vibePassContext),
    ...(params.metadata_json || {}),
  };

  return Object.fromEntries(
    Object.entries(metadata).filter(([, value]) => value !== null && value !== undefined && value !== "")
  );
}

export function trackUsefulServiceEvent(eventType, params = {}) {
  if (typeof window === "undefined") return;

  const pagePath = params.page_path || window.location.pathname || "/useful-services";

  void trackPlatformEvent(eventType, {
    page_path: pagePath,
    city: params.city || params.destination || "Benalmádena",
    category: "useful_services",
    metadata_json: buildMetadata({
      source_page: window.location.pathname,
      ...params,
    }),
  });
}
